import { GroupFilterError } from "~/components/collect/group-filter-error";
import { GroupFilterSkeleton } from "~/components/collect/group-filter-skeleton";
import { GroupFilter } from "~/components/collect/operator/group-filter";
import { type SelectorFilterLayer } from "~/components/collect/operator/use-selector-filter";

type GroupFilterRegionProps = {
  /** The school query status — this island reflects only the school. */
  status: "pending" | "error" | "success";
  /** Whether the taxonomy yields a filter worth showing. */
  isActive: boolean;
  layers: SelectorFilterLayer[];
  onRetry: () => void;
  isRetrying: boolean;
};

/**
 * Sidebar year/class filter as an independent island: error card, skeleton, or
 * the filter — driven solely by the school query, never the student list.
 */
export const GroupFilterRegion = ({
  status,
  isActive,
  layers,
  onRetry,
  isRetrying
}: GroupFilterRegionProps) => {
  if (status === "error") {
    return <GroupFilterError onRetry={onRetry} disabled={isRetrying} />;
  }
  if (status === "pending") {
    return <GroupFilterSkeleton />;
  }
  if (!isActive) {
    return null;
  }
  return (
    <GroupFilter>
      {layers.map((layer) => (
        <GroupFilter.Layer
          key={layer.key}
          label={layer.label}
          options={layer.options}
          selected={layer.selected}
          onSelect={layer.onSelect}
        />
      ))}
    </GroupFilter>
  );
};
